import { FC } from 'react';

import { useIsPayee } from 'app/api/hooks/core/v1/auth/user';
import LogoLink from 'app/components/layout/AppLayout/LogoLink';
import Box from 'app/components/v2/components/Box';
import { keys } from 'app/config/keys';
import { useIsTriumphInternal } from 'app/state/AuthContext/hooks';

import AccountMenu from './AccountMenu';
import PayeeGlobalSearch from '../NavGlobalSearch/PayeeGlobalSearch';
import { NavProps } from '..';

const isGlobalSearchEnabled = keys.NODE_ENV !== 'production' && keys.NODE_ENV !== 'onboarding';

// Component Definition
const DesktopNav: FC<NavProps> = props => {
  const isTriumphInternal = useIsTriumphInternal();
  const isPayee = useIsPayee();

  return (
    <Box
      alignItems="center"
      display="flex"
      gap={6}
      justifyContent="space-between"
      paddingX={6}
      paddingY={3}
    >
      <LogoLink
        size="large"
        to={props.logoPath}
        variant="light"
      />

      {isGlobalSearchEnabled && isPayee && (
        <PayeeGlobalSearch />
      )}

      <Box
        alignItems={isTriumphInternal ? 'flex-end' : 'center'}
        display="flex"
        flexDirection={isTriumphInternal ? 'column-reverse' : 'row'}
        role="navigation"
      >
        <AccountMenu
          shouldRenderCompanyName
          shouldRenderCompanyType={isTriumphInternal}
        />
      </Box>
    </Box>
  );
};

export default DesktopNav;
